/**
 * Les mesures de `<VideoTile>` que la scène du live lit pour placer ce qu'elle pose dessus sans rien
 * cacher (`organisms/LiveStage/stageLayout.ts`). Pures : elles se lisent sous Jest.
 */

/** La vignette en coin de la scène : en portrait, comme une caméra de téléphone. */
export const VIDEO_THUMB = { width: 96, height: 128 } as const
/** La marge d'une pastille d'état dans sa vidéo (`spacing.1`). */
export const MARK_INSET = 4
/** Une pastille d'état (micro coupé, main levée) sur la vidéo de la scène. */
export const STAGE_MARK = 32
/** Le nom sur la vidéo de la scène ne dépasse pas cette part de sa largeur : le coin bas droit reste libre. */
export const STAGE_NAME_MAX_RATIO = 0.55
